import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";


import { TranslateModule } from "@ngx-translate/core";

import { AttachmentChipsComponent } from './attachment-chips.component';
import { GridMediaViewerModule } from "../grid-media-viewer/grid-media-viewer.module";
import { TableModule } from "../table/table.module";
import { TabsModule } from "../tabs/tabs.module";
import { IconModule } from "../../default/icon/icon.module";
import { PipesModule } from "../../../pipes/pipes.module";
import { DirectivesModule } from "../../../directives/directives.module";
import { ProgressSpinnerModule } from "../../default/progress-spinner/progress-spinner.module";
import { AngularMaterialModule } from "../../../../core/angular-material/angular-material.module";
import { WindowLoadingModule } from "../../default/window-loading/window-loading.module";
import { LinkModule } from "../../default/link/link.module";
import { UploadModule } from "../../default/upload/upload.module";




@NgModule({
    declarations: [
        AttachmentChipsComponent
    ],
    exports: [
        AttachmentChipsComponent
    ],
    imports: [
        CommonModule,
        DirectivesModule,
        PipesModule,
        FormsModule,
        IconModule,
        ProgressSpinnerModule,
        TableModule,
        TabsModule,
        ReactiveFormsModule,
        AngularMaterialModule,
        WindowLoadingModule,
        LinkModule,
        TranslateModule,
        UploadModule,
        GridMediaViewerModule,
    ]
})
export class AttachmentChipsModule { }
